<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-no-network-detected-modal [class.modal-offline-show]="!isOnline" [class.modal-offline-hide]="isOnline" ></app-no-network-detected-modal>
</ion-app>
